<template>
  <div class="content">
    <SectionLoader v-if="showLoading" status :opacity="1" />
    <template v-else>
      <EmptyState v-if="!accounts.length" />
      <AccountsExpansionPanel
        v-else
        :accounts="accounts"
        :loading="isLocalLoading"
        @delete-account="deleteAccount"
        @delete-page="deletePage"
      />
    </template>
  </div>
</template>

<script>
import facebookService from "@/services/facebook";
import serviceHandler from "@/helpers/handlers/service";
import AccountsExpansionPanel from "@/components/FacebookAccounts/AccountsExpansionPanel.vue";
import EmptyState from "@/components/FacebookAccounts/EmptyState.vue";
import SectionLoader from "@/components/Loader/SectionLoader.vue";

export default {
  name: "AccountsContainer",
  components: {
    AccountsExpansionPanel,
    EmptyState,
    SectionLoader
  },
  props: {
    isParentLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      accounts: null,
      isLocalLoading: false
    };
  },
  computed: {
    showLoading() {
      return this.isParentLoading || this.isLocalLoading;
    }
  },
  async created() {
    await this.fetchAccounts();
  },
  methods: {
    async deleteAccount(id) {
      this.fetchAccounts(async () => {
        await serviceHandler(facebookService.deleteAccount(id));
      });
    },
    async deletePage(id) {
      this.fetchAccounts(async () => {
        await serviceHandler(facebookService.deletePage(id));
      });
    },
    async getAccountsList() {
      this.accounts = await serviceHandler(facebookService.getAccounts());
      this.$emit("accounts-loaded", this.accounts.length);
    },
    async fetchAccounts(callback = () => {}) {
      this.isLocalLoading = true;
      await callback();
      await this.getAccountsList();
      this.isLocalLoading = false;
    }
  }
};
</script>
<style scoped lang="scss">
.content {
  min-height: 150px;
}
</style>
